import { lazyLoadImages, lozadLoad } from "./functions";

document.addEventListener('DOMContentLoaded', lazyLoadImages);

if (document.querySelector('.wp-twitter-embed')) {
document.addEventListener('DOMContentLoaded', lozadLoad);
}